import { Typography, Menu } from '@mui/material';
import { styled } from '@mui/material/styles';

export default function Dropdown({
  label = 'Select action:',
  anchorEl,
  opened,
  handleClose,
  children,
  position,
}) {
  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={opened}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      className="p-16"
      position={position}
    >
      {label && (
        <Typography className="font-600 text-12 text-typography-thirty px-12 pt-12 pb-6">
          {label}
        </Typography>
      )}
      {children}
    </StyledMenu>
  );
}

const StyledMenu = styled(({ position, ...props }) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: position?.anchorVertical || 'bottom',
      horizontal: position?.anchorHorizontal || 'right',
    }}
    transformOrigin={{
      vertical: position?.transformVertical || 'top',
      horizontal: position?.transformHorizontal || 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    minWidth: '150px',
    borderRadius: '4px',
    boxShadow:
      '0px 0px 0.5px rgba(66, 71, 76, 0.32), 0px 4px 8px rgba(66, 71, 76, 0.05), 0px 4px 20px rgba(0, 0, 0, 0.16);',
  },
  '& .MuiList-root': {
    padding: 0,
  },
  '& .MuiMenuItem-root': {
    padding: '6px 12px',
  },
}));
